import BlogSeventeenContainer from "./container/BlogSeventeenContainer";
export default BlogSeventeenContainer;
